import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.ReportsRequestPage.PrintPreviewNotificationPopup', {
    description: 'Print preview is opened in a separate window',
    buttonClose: 'Close Print Preview',
});
